import { WorkOrderStatusEnum } from '@ztechapps/common.contract'

/**
 * A closed work order is done — Cancelled or Destructed. Neither is reachable from the
 * other (`WorkOrderStateTransition.moveToState` blocks every move out of both), so a
 * "closed" check never needs to distinguish which one it is.
 *
 * Precedent: `libs/logistic/common/src/utils/isLogisticEditLocked.ts:21`.
 */
export const isWorkOrderClosed = (status?: WorkOrderStatusEnum): boolean =>
  status === WorkOrderStatusEnum.Cancelled || status === WorkOrderStatusEnum.Destructed

// Precedent: `libs/logistic/common/src/utils/getShippingPhoneBlockReason.ts:4`.
export const WORK_ORDER_CLOSED_STATUS_MESSAGE = 'The status cannot be changed because the production is closed.'
